import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/api/client";
import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";

export default function OutreachBell() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [count, setCount] = useState(0);

  const load = useCallback(() => {
    if (!user || user.role === "field_agent") return;
    api.get("/outreach/summary")
      .then(({ data }) => setCount(data.needs_attention || 0))
      .catch(() => {});
  }, [user]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener("avida-outreach-updated", h);
    window.addEventListener("focus", h);
    return () => {
      window.removeEventListener("avida-outreach-updated", h);
      window.removeEventListener("focus", h);
    };
  }, [load]);

  if (!user || user.role === "field_agent") return null;

  return (
    <button
      data-testid="outreach-bell"
      onClick={() => nav("/outreach")}
      title="Partner outreach — follow-ups due"
      className="relative p-2 rounded-md text-white/65 hover:text-[#FFCB05] hover:bg-white/10"
    >
      <Building2 className="h-4 w-4" />
      {count > 0 && (
        <span
          data-testid="outreach-bell-count"
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 grid place-items-center rounded-full bg-[#b91c1c] text-white text-[9px] font-extrabold ring-2 ring-[#15233B]"
        >
          {count}
        </span>
      )}
    </button>
  );
}
